import { initBreadcrumbs } from '../../../utilities/helpers'

export default {
  name: 'agents',
  props: {
    signedInUser: Object
  },
  data () {
    return {
      breadcrumbs: []
    }
  },
  watch: {
    $route () {
      this.breadcrumbs = this.buildBreadcrumbs()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.breadcrumbs = this.buildBreadcrumbs()
    })
  },
  methods: {
    buildBreadcrumbs () {
      const breadcrumbs = initBreadcrumbs.call(this)
      if (this.$route.name !== 'agents-agent-transactions' || !this.$route.params.agentId) {
        return breadcrumbs
      }
      breadcrumbs.splice(Math.max(breadcrumbs.length - 1, 0), 0, {
        text: 'Agent',
        disabled: false,
        to: { name: 'agents-agent', params: { agentId: this.$route.params.agentId } },
        'active-class': ''
      })
      return breadcrumbs
    },
    onCreateAgentClicked () {
      this.$router.push({ name: 'agents-agent', params: { agentId: '0' } })
    },
    onAgentSelected (agent) {
      this.$router.push({ name: 'agents-agent', params: { agentId: agent.id } })
    },
    onAgentTransactionsSelected (agent) {
      this.$router.push({ name: 'agents-agent-transactions', params: { agentId: agent.id } })
    }
  }
}
